import { Box, Checkbox, DestructiveModal, Flex, Text } from '@modusign/design-system';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';

import { CharacterCountVisibleTextarea } from '@app/components/Form';
import DocumentRole from '@app/store/documents/DocumentRole';

import './RejectDocumentModal.scss';

const propTypes = {
  documentId: PropTypes.string,
  documentRole: PropTypes.oneOf([DocumentRole.PARTICIPANT, DocumentRole.REQUESTER]),
  participantId: PropTypes.string,
  t: PropTypes.func,
  userName: PropTypes.string,
  onCancel: PropTypes.func,
  onRejectDocument: PropTypes.func,
};

const defaultProps = {
  documentId: '',
  documentRole: null,
  participantId: '',
  userName: '',
  onCancel() {},
  onRejectDocument() {},
};

class RejectDocumentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDocumentBlock: false,
      value: '',
      validityMessage: '',
      validityOn: false,
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckClick = this.handleCheckClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleBlur() {
    this.setState({ validityOn: true });
  }

  handleChange(value) {
    const { t } = this.props;

    this.setState({ value });

    if (value.length < 2) {
      this.setState({ validityMessage: t('RejectDocumentModal-lengthRejectionValidityMessage') });
    } else {
      this.setState({ validityMessage: '' });
    }
  }

  handleCheckClick() {
    const { isDocumentBlock } = this.state;
    this.setState({ isDocumentBlock: !isDocumentBlock });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { documentId, participantId, onCancel, onRejectDocument } = this.props;
    const { isDocumentBlock, value } = this.state;

    this.handleBlur();
    this.handleChange(value);

    if (value.length >= 2) {
      onRejectDocument({
        documentId,
        participantId,
        message: value,
        isDocumentBlock,
      });
      onCancel();
    }
  }

  render() {
    const { isDocumentBlock, value, validityOn, validityMessage } = this.state;
    const { documentRole, t, userName, onCancel } = this.props;

    return (
      <DestructiveModal
        closeButtonLabel={t('Global-cancel')}
        confirmButtonLabel={t('RejectDocumentModal-submitButton')}
        isOpen
        maxWidth="xs"
        title={t('RejectDocumentModal-title')}
        onClose={onCancel}
        onConfirm={this.handleSubmit}
      >
        <Flex flexDirection="column" sx={{ gap: 20 }}>
          <Text as="p" textAlign="center">
            {t('RejectDocumentModal-description')}
          </Text>
          <form>
            <div
              className={cx('InputSet', {
                'InputSet--invalid': validityOn && validityMessage,
              })}
            >
              <CharacterCountVisibleTextarea
                name="comment"
                placeholder={t('RejectDocumentModal-textareaPlaceholder')}
                value={value}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
              />
              {validityOn && validityMessage && (
                <p className="InputSet__invalidity-message">{validityMessage}</p>
              )}
            </div>
            {documentRole === DocumentRole.REQUESTER && (
              <Flex as="label">
                <Box flex="1 0 20px">
                  <Checkbox isChecked={isDocumentBlock} onClick={this.handleCheckClick} />
                </Box>
                <Text as="p">{t('RejectDocumentModal-blockViewMessage', { userName })}</Text>
              </Flex>
            )}
          </form>
        </Flex>
      </DestructiveModal>
    );
  }
}

RejectDocumentModal.propTypes = propTypes;
RejectDocumentModal.defaultProps = defaultProps;

export default withTranslation()(RejectDocumentModal);
